import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/shared/ui/tokens.css';
import '@/shared/lib/i18n';
import { initSentry } from '@/shared/lib/observability/sentry';
import { App } from '@/app/App';

initSentry();

const container = document.getElementById('root');
if (!container) {
  throw new Error('root element missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the service worker in production only. In dev it would fight
// Vite's HMR (the SW caches navigations); the e2e suite also runs on the
// dev server, so PROD-gating keeps it hermetic. Install + Web Push are
// testable via `pnpm build && pnpm preview` or the deployed app.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Non-fatal: the app runs without the SW; PWA install + push stay off.
    });
  });
}
